
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class LevelChart extends ChartMixin {
  @Prop({ type: Object, required: true }) chartDataCurrent!: { x: number; y: number };
  @Prop({ type: Object, required: true }) chartDataLast!: { x: number; y: number; isDisp: boolean };
  @Ref("behavior-table") behaviorTable!: HTMLElement;
  @Ref("behavior-axis-current") behaviorAxisCurrent!: HTMLElement;
  @Ref("behavior-axis-last") behaviorAxisLast!: HTMLElement;
  calculatePositionCurrent(x: number, y: number) {
    x = Math.min(Math.max(x, 30), 70);
    y = Math.min(Math.max(y, 30), 70);
    this.$nextTick(() => {
      const tableWidth = this.behaviorTable.clientWidth;
      const tableHeight = this.behaviorTable.clientHeight;
      const borderSize = 1;
      const coefX = 0.25 * ((x - 30) / 10);
      const coefY = 0.25 * ((y - 30) / 10);
      const calcX = ((tableWidth * coefX) / tableWidth) * 100;
      const calcY = ((tableHeight * coefY) / tableHeight) * 100;
      (this.behaviorAxisCurrent.style.left = `calc(${calcX}% - ${(x >= 50 ? borderSize : -borderSize) + 5}px)`),
      (this.behaviorAxisCurrent.style.bottom = `calc(${calcY}% - ${(y >= 50 ? borderSize : -borderSize) + 5}px)`);
    });
  }

  calculatePositionLast(x: number, y: number) {
    x = Math.min(Math.max(x, 30), 70);
    y = Math.min(Math.max(y, 30), 70);
    this.$nextTick(() => {
      const tableWidth = this.behaviorTable.clientWidth;
      const tableHeight = this.behaviorTable.clientHeight;
      const borderSize = 1;
      const coefX = 0.25 * ((x - 30) / 10);
      const coefY = 0.25 * ((y - 30) / 10);
      const calcX = ((tableWidth * coefX) / tableWidth) * 100;
      const calcY = ((tableHeight * coefY) / tableHeight) * 100;
      (this.behaviorAxisLast.style.left = `calc(${calcX}% - ${(x >= 50 ? borderSize : -borderSize) + 5}px)`),
      (this.behaviorAxisLast.style.bottom = `calc(${calcY}% - ${(y >= 50 ? borderSize : -borderSize) + 5}px)`);
    });
  }
}
